var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Route } from "react-router";
import authentication from "@irati/auth";
import { IndexRedirect, PartialRoute } from "@irati/utils/history/routing";
import { LangLoader } from "@irati/utils/lang";
import AppContainer from "@irati/ui/src/AppContainer";
import { FIELDS } from "@irati-web/fields/index";
import { ACCOUNT, MEDICAL } from "@irati-web/app/src/routeConfig";
import { greys } from "@irati/ui/src/global/colors";
import Home from "../containers/Home";
import Reports from "../containers/MedicalReports";
import MedicalUpsell from "../containers/Home/MedicalUpsell/MedicalUpsell";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indexRoute = function () { return (authentication.apps("medical") ? "/my-medical" : "/up-sell"); };
        return _this;
    }
    default_1.prototype.render = function () {
        var _this = this;
        var path = this.props.path;
        return (React.createElement(LangLoader, { buckets: [MEDICAL, ACCOUNT, FIELDS] },
            React.createElement(Route, { path: path, render: function () { return (React.createElement(AppContainer, { mainBackground: greys.white },
                    React.createElement(React.Fragment, null,
                        React.createElement(PartialRoute, { permission: "medical", match: path, exact: true, path: "/my-medical", component: Home, title: "My Medical" }),
                        React.createElement(PartialRoute, { permission: "medical.reports", match: path, exact: true, path: "/reports", component: Reports, title: "Reports" }),
                        React.createElement(PartialRoute, { match: path, exact: true, path: "/up-sell", component: MedicalUpsell, title: "Get Medical" }),
                        React.createElement(IndexRedirect, { match: { url: path }, to: _this.indexRoute() })))); } })));
    };
    return default_1;
}(Component));
export default default_1;
